import { SAVE_REFERENCE_CLICKS } from "@/graphql/mutation/save-reference-clicks"
import BrowserPersistence from "@/util/simplePersistence"
import { useMutation } from "@apollo/client"
import { useSearchParams } from "next/navigation"
import { useEffect } from "react"

const RecordInfluencer = () => {
  const searchParams = useSearchParams()
  const [saveReferenceClicks] = useMutation(SAVE_REFERENCE_CLICKS)

  useEffect(() => {
    // 红人跟踪相关逻辑

    const referenceClick = () => {
      const source = searchParams.get("source")
      const code = searchParams.get("code")

      if (source && code) {
        const storage = new BrowserPersistence()

        if (
          !storage.getItem("influencer_source") ||
          !storage.getItem("influencer_code")
        ) {
          storage.setItem("influencer_source", source)
          storage.setItem("influencer_code", code)

          saveReferenceClicks({
            variables: {
              source,
              code,
            },
          }).catch(console.error)
        }
      }
    }

    referenceClick()
  }, [saveReferenceClicks, searchParams])

  return null
}

export default RecordInfluencer
